import React from 'react';
import { X, Check } from 'lucide-react';
export function BeforeAfter() {
  const before = ['Improvisa el domingo a la noche', 'Repite las mismas 10 rutinas', 'Busca videos sueltos en Instagram', 'Alumnos se aburren y se van'];
  const after = ['Abre el sistema y la clase está lista', '300+ clases con progresión real', 'Sigue un plan de 52 semanas', 'Grupo motivado, turnos llenos'];
  return <section className="py-16 md:py-24 px-4 bg-surface/30 border-y border-zinc-800/50" data-id="element-21">
      <div className="max-w-5xl mx-auto" data-id="element-22">
        <div className="text-center mb-12 md:mb-16" data-id="element-23">
          <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-24">
            La transformación
          </p>
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight" data-id="element-25">
            DEL PROFE AGOTADO <span className="text-zinc-600" data-id="element-26">AL</span>{' '}
            <span className="text-primary" data-id="element-27">PROFE HIIT PRO</span>
          </h2>
        </div>

        <div className="relative grid md:grid-cols-2 gap-6 md:gap-10" data-id="element-28">
          {/* VS badge */}
          <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10 w-16 h-16 rounded-full bg-black border-2 border-primary items-center justify-center font-space-grotesk font-extrabold text-primary shadow-[0_0_30px_rgba(249,168,212,0.3)]" data-id="element-29">
            VS
          </div>

          {/* BEFORE */}
          <div className="bg-black border border-zinc-800 rounded-3xl p-8 md:p-10" data-id="element-30">
            <div className="flex items-center gap-3 mb-8" data-id="element-31">
              <div className="w-12 h-12 rounded-2xl bg-red-500/10 flex items-center justify-center shrink-0" data-id="element-32">
                <X className="w-6 h-6 text-red-500" data-id="element-33" />
              </div>
              <h3 className="text-xl md:text-2xl font-extrabold text-zinc-400" data-id="element-34">
                El profe agotado
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-35">
              {before.map((item, i) => <li key={i} className="flex items-start gap-3 text-base md:text-lg text-zinc-500 font-medium" data-id="element-36">
                  <X className="w-5 h-5 text-red-500/70 shrink-0 mt-0.5" data-id="element-37" />
                  {item}
                </li>)}
            </ul>
          </div>

          {/* AFTER */}
          <div className="bg-surface border-2 border-primary rounded-3xl p-8 md:p-10 relative shadow-[0_0_50px_rgba(249,168,212,0.12)]" data-id="element-38">
            <div className="flex items-center gap-3 mb-8" data-id="element-39">
              <div className="w-12 h-12 rounded-2xl bg-primary/20 flex items-center justify-center shrink-0" data-id="element-40">
                <Check className="w-6 h-6 text-primary" data-id="element-41" />
              </div>
              <h3 className="text-xl md:text-2xl font-extrabold text-white" data-id="element-42">
                El profe HIIT Pro
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-43">
              {after.map((item, i) => <li key={i} className="flex items-start gap-3 text-base md:text-lg text-zinc-100 font-semibold" data-id="element-44">
                  <Check className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-45" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}